<template>
  <v-dialog v-model="show" max-width="500" persistent>
    <v-card>
      <v-card-title>
        {{ refund ? $t("finance_edit_refund_title") : $t("finance_request_refund_title") }}
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-form ref="form" v-model="valid">
          <text-field
            v-model="form.orderRef"
            :label="$t('finance_order_number')"
            prependInnerIcon="mdi-pound"
            :rules="[rules.required]"
          />
          <text-field
            v-model="form.customer"
            :label="$t('finance_customer')"
            kind="user"
            :rules="[rules.required]"
          />
          <text-field
            v-model="form.reason"
            :label="$t('finance_reason')"
            prependInnerIcon="mdi-message-alert-outline"
            :rules="[rules.required]"
          />
          <text-field
            v-model.number="form.amount"
            :label="$t('finance_amount_currency', { currency: restaurantCurrency })"
            type="number"
            kind="money"
            :rules="[rules.required, rules.positive]"
          />
          <text-field
            v-model="form.method"
            :label="$t('finance_refund_method_optional')"
            prependInnerIcon="mdi-credit-card-outline"
          />
          <text-area
            v-model="form.comment"
            :label="$t('finance_comment_optional')"
            rows="2"
          />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="saving" @click="close">{{ $t("finance_cancel") }}</v-btn>
        <primary-button :loading="saving" @click="submit">{{ $t("finance_save") }}</primary-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const emptyForm = () => ({
  orderRef: "",
  customer: "",
  reason: "",
  amount: 0,
  method: "",
  comment: "",
});

export default {
  name: "RefundFormDialog",

  props: {
    value: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
    refund: { type: Object, default: null },
  },

  data() {
    return {
      valid: true,
      form: emptyForm(),
      rules: {
        required: (v) => (v !== null && v !== undefined && v !== "") || this.$t("finance_required_field"),
        positive: (v) => Number(v) > 0 || this.$t("finance_amount_must_be_positive"),
      },
    };
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    value(isOpen) {
      if (!isOpen) return;
      if (this.refund) {
        this.form = {
          orderRef: this.refund.orderRef,
          customer: this.refund.customer,
          reason: this.refund.reason,
          amount: this.refund.amount,
          method: this.refund.method || "",
          comment: this.refund.comment || "",
        };
      } else {
        this.form = emptyForm();
      }
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
    },
  },

  methods: {
    close() {
      this.$emit("input", false);
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      this.$emit("save", {
        order_ref: this.form.orderRef,
        customer: this.form.customer,
        reason: this.form.reason,
        amount: Number(this.form.amount),
        method: this.form.method || undefined,
        comment: this.form.comment || undefined,
      });
    },
  },
};
</script>
